var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#activeHeart)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2143 19.5319C12.5306 20.1575 11.478 20.1575 10.7942 19.5229L10.6953 19.4322C5.97207 15.1255 2.88626 12.3057 3.00321 8.78783C3.05719 7.24649 3.83989 5.76861 5.1084 4.8982C7.48349 3.26619 10.4164 4.02779 11.9998 5.89554C13.5831 4.02779 16.516 3.25712 18.8911 4.8982C20.1596 5.76861 20.9423 7.24649 20.9963 8.78783C21.1222 12.3057 18.0274 15.1255 13.3043 19.4503L13.2143 19.5319Z",
    fill: "#FF6B72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "activeHeart"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHeart);
export default __webpack_public_path__ + "static/media/activeHeart.ced05e1d57fbf37d0279011f29272e37.svg";
export { ForwardRef as ReactComponent };